<app-header *ngIf="showHeadFoot"></app-header>
<router-outlet></router-outlet>
<!-- <app-muharram-modal *ngIf="showModal"></app-muharram-modal> -->
<app-footer *ngIf="showHeadFoot && showFoot"></app-footer>